/**
 * @generated SignedSource<<d557b0d879f5cd21fba925f349470307>>
 * @relayHash f6c5d5ff2079a55a0b1db15579eee8da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5a3248326d2e2f9b8a01e4fb3c9f7737a8132eec6cd51408c63f2b026da11ccd

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AtlaskitAtlassianNavigationNav4Query$variables = Record<PropertyKey, never>;
export type AtlaskitAtlassianNavigationNav4Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Profile">;
};
export type AtlaskitAtlassianNavigationNav4Query = {
  response: AtlaskitAtlassianNavigationNav4Query$data;
  variables: AtlaskitAtlassianNavigationNav4Query$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AtlaskitAtlassianNavigationNav4Query",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "Nav4Profile"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AtlaskitAtlassianNavigationNav4Query",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  }
                ],
                "type": "AtlassianAccountUser"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5a3248326d2e2f9b8a01e4fb3c9f7737a8132eec6cd51408c63f2b026da11ccd",
    "metadata": {},
    "name": "AtlaskitAtlassianNavigationNav4Query",
    "operationKind": "query",
    "text": null
  }
};

(node as any).hash = "117383646be1f212dbc165252eccb286";

export default node;
